import {styled} from "@mui/styles";
import {Card} from "@mui/material";

export const PaddedCard = styled(Card)({
    margin: 10,
});